import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/dist/query';
import type { Middleware } from 'redux';

import { baseApi } from '@klp/core/api';
import { appDispatch } from '@klp/core/app';
import { contractRegistrationListenerMiddleware } from '@klp/contractregistration/listenerMiddleware';

import { reducers } from './reducers';

export { reducers };

const errorMiddleware: Middleware = () => (next) => (action) => {
    const { dispatchErrorOccured } = appDispatch(rootStore.dispatch);
    try {
        return next(action);
    } catch (error) {
        dispatchErrorOccured(error);
    }
};

const middleware = [
    baseApi.middleware,
    contractRegistrationListenerMiddleware.middleware,
    errorMiddleware,
];

const initStore = configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(middleware),
});

setupListeners(initStore.dispatch);

export const rootStore = initStore;

export type RootState = ReturnType<typeof rootStore.getState>;
export type AppDispatch = typeof rootStore.dispatch;
